import React, { Component } from 'react';
import { connect } from 'react-redux';
import './updateProfile.scss';
import { Button, message } from 'antd';
import NoImage from "../../../images/no-image.jpg";
import EditIcon from "../../../images/edit-icon.png";
import { saveFirmAdress, uploadFirmAdress, approveRejectUserDocument, approveRejectFirmDetail } from '../action/user.actions'
import { fromValidate } from '../../../helpers';
import _ from 'lodash';
import { imageEndpoint } from '../../../services/endpoint';

class FirmDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firm_address: {},
      document: {},
      doc: {},
      user_firm_address: {}
    }
  }

  componentDidMount() {
    const { user } = this.props;
    this.setState({ firm_address: user.firm_address }, () => {
      this.getLocation();
    });

  }
  componentWillReceiveProps( props){
    const { user, userDetails } = props;
    const user_firm_address = user.role.name == 'Admin' ? (userDetails.firm_address) || [] : (user.firm_address ) || [];
    const document = user.role.name == 'Admin' ? (userDetails.firm_address && userDetails.firm_address.documents) || [] : (user.firm_address && user.firm_address.documents) || [];
    const doc = _.first(document);
    this.setState({doc: doc, user_firm_address: user_firm_address});
  }

  handleChange = (e) => {
    const firm_address = Object.assign({}, this.state.firm_address)
    const name = e.target.name;
    const value = e.target.value;
    firm_address[name] = value;
    this.setState({ firm_address });
  }

  createFormData = (body) => {
    let data = new FormData();
    Object.keys(body).forEach(key => {
      data.append(key, body[key]);
    });
    return data;
  };

  onSelectFile = (e) => {
    const { user } = this.props;
    const document = Object.assign({}, this.state.document)
    let file = e.target.files[0];
    if (file) {
      document.photo = file;
      document.user_id = user.id;
      document.document_type = file.type;
      document.document_name = document.document_name || 'Firm Rent Agreement';
      this.setState({ document: document })
    }
    // dispatch(uploadIdentityverification(user.id, formData))
  }

  onSelectDocumentName = (e) => {
    const document = Object.assign({}, this.state.document);
    document.document_name = e.target.value;
    this.setState({ document: document })
  }

  getLocation = () => {

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const firm_address = Object.assign({}, this.state.firm_address)
        firm_address.location_latitude = position.coords.latitude;
        firm_address.location_longitude = position.coords.longitude;
        this.setState({ firm_address });
      });
    }
  }

  saveFirmAddress = (e) => {
    const { user, dispatch } = this.props;
    let { firm_address, document } = this.state;
    e.preventDefault();
    this.setState({ formError: {}, formSubmit: true })
    const formValidation = fromValidate(e.target);
    if (!formValidation.valid) {
      this.setState({ formError: formValidation.invalidationEle })
    }
    else {

      if (_.get(firm_address, 'location_latitude')) {
        let req = {
          "user_id": user.id,
          "address_line1": firm_address.address_line1,
          "address_line2": firm_address.address_line2,
          "firm_name": firm_address.firm_name,
          "gst_no": firm_address.gst_no,
          "pan": firm_address.pan,
          "entity_reg_no": firm_address.entity_reg_no,
          "city": firm_address.city,
          "state": firm_address.state,
          "country": firm_address.country,
          "zip": firm_address.zip,
          "location_latitude": firm_address.location_latitude,
          "location_longitude": firm_address.location_longitude
        };
        
        dispatch(saveFirmAdress(user.id, req))
          .then((res) => {
            if (document) {
              let fromData = this.createFormData(document)
              dispatch(uploadFirmAdress(user.id, fromData));
              this.setState({ document: {} })
            }
          });
      } else {
        message.error(`Please locate yourself before saving the address!`);
      }
    }
  }
  approveRejectUserDocument = (id, status) => {
    const {dispatch, user} = this.props;
    const data = {
      document_id: id,
      status: status
    }
    dispatch(approveRejectUserDocument(data,  user.id)).then((res) => {
      let doc = [...this.state.doc];
      let currentDoc = doc.find(e => e.id == id);
      currentDoc.status = status == "V" ? "Verified" : "Rejected";
      this.setState({document: doc})
    })
    .catch((err) => {
      console.log(err);
    });;
  }
  approveRejectFirmDetail = (id, status) =>{
    const {dispatch} = this.props;
    const data = {
      user_id: id,
      status: status
    }
    dispatch(approveRejectFirmDetail(data)).then((res)=>{
      let doc = this.state.user_firm_address;
      doc.status = status == "V" ? "Verified" : "Rejected";
      this.setState({user_firm_address: doc})
    })
    .catch((err) => {
      console.log(err);
    });
  }

  render() {
    const { user, userDetails } = this.props;
    const role  = user.role.name;
    const { firm_address } = this.state;
    const document = role == 'Admin' ? (userDetails.firm_address && userDetails.firm_address.documents) || [] : (user.firm_address && user.firm_address.documents) || [];
    const {doc, user_firm_address} = this.state;

    return (
      <div className="form-main-cont-box">
        <div className="upprof-heading-txt">Firm Detail
          {
            role == "Admin" && 
            <span className='verification-button-container'>
              <Button type="button" disabled={user_firm_address.status === "Verified"}  className="ant-btn btn-login" onClick={() => { this.approveRejectFirmDetail(userDetails.id, 'V')}} ><span>{user_firm_address.status == "V"? "Approved" : "Approve Firm Detail"}</span></Button>
              <Button type="button" disabled={user_firm_address.status === "Rejected"} className="ant-btn btn-reject" onClick={() => { this.approveRejectFirmDetail(userDetails.id, 'R')}}><span>{user_firm_address.status == "R"? "Rejected" : "Reject Firm Detail"}</span></Button>
            </span>
          }
        </div>
        <form ref={node => this.fromNode = node} noValidate autoComplete="off" onSubmit={(e) => { this.saveFirmAddress(e) }}>

          <div className="row row-padding">
            <div className="col-sm-12 col-md-8 col-xs-12">

              <div className="row">
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == 'Admin' && <label>{firm_address.firm_name}</label>
                  }{
                    role != 'Admin' && 
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Firm Name"
                      name="firm_name"
                      value={firm_address.firm_name}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                  }
                </div>
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == 'Admin' && <label>{firm_address.gst_no}</label>
                  }{
                    role != 'Admin' && 
                    <input
                    type="text"
                    className='prof-textfield-containt'
                    placeholder="GST"
                    name="gst_no"
                    value={firm_address.gst_no}
                    onChange={(e) => { this.handleChange(e) }}
                  />
                  }
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == 'Admin' && <label>{firm_address.pan}</label>
                  }{
                    role != 'Admin' && 
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Pan"
                      name="pan"
                      value={firm_address.pan}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                  }
                </div>
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == 'Admin' && 
                    <label>{firm_address.entity_reg_no}</label>
                  }{
                    role != 'Admin' && 
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Entry Regn No."
                      name="entity_reg_no"
                      value={firm_address.entity_reg_no}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                  }
                  
                </div>
              </div>
              <div>
                {
                  role == "Admin" && <label>{firm_address.address_line1}</label>
                }{
                  role != "Admin" &&
                  <input
                    type="text"
                    required
                    className='prof-textfield-containt'
                    placeholder="Address 1"
                    name="address_line1"
                    value={firm_address.address_line1}
                    onChange={(e) => { this.handleChange(e) }}
                  />
                }
              </div>
              <div>
                {
                  role == "Admin" && <label>{firm_address.address_line2}</label>
                }{
                  role != "Admin" &&
                  <input
                    type="text"
                    className='prof-textfield-containt'
                    placeholder="Address 2"
                    name="address_line2"
                    value={firm_address.address_line2}
                    onChange={(e) => { this.handleChange(e) }}
                  />
                }
                
                
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == "Admin" && <label>{firm_address.city}</label>
                  }{
                    role != "Admin" &&  
                    <input
                      type="text"
                      required
                      className='prof-textfield-containt'
                      placeholder="City"
                      name="city"
                      value={firm_address.city}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                  }
                </div>
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == "Admin" && <label>{firm_address.state}</label>
                  }{
                    role != "Admin" &&
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="State"
                      required
                      name="state"
                      value={firm_address.state}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                  }
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == "Admin" && <label>{firm_address.country}</label>
                  }{
                    role != "Admin" &&
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Country"
                      name="country"
                      required
                      value={firm_address.country}
                      onChange={(e) => { this.handleChange(e) }}
                    /> 
                  }
                </div>
                <div className="col-sm-12 col-md-6 col-xs-12">
                  {
                    role == "Admin" && <label>{firm_address.zip}</label>
                  }{
                    role != "Admin" && 
                    <input
                      type="text"
                      className='prof-textfield-containt'
                      placeholder="Zip"
                      name="zip"
                      required
                      value={firm_address.zip}
                      onChange={(e) => { this.handleChange(e) }}
                    />
                  }
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  {
                    role != "Admin" && <Button htmlType="button"
                    onClick={() => { this.getLocation() }}
                    className='btn-login'>Locate me</Button>
                  }
                    ({firm_address.location_latitude},
                    {firm_address.location_longitude})
                </div>

              </div>

            </div>
            <div className="col-sm-12 col-md-4 col-xs-12">
              <div>
                <div className="doc-img-box">
                  <div>
                    {
                      role == "Admin" && <label>{document.document_name}</label> 
                    }{
                      role != "Admin" && 
                      <select
                        className='prof-textfield-containt'
                        placeholder="DocumentType"
                        required
                        value={document.document_name}
                        name="document_name" onChange={(e) => { this.onSelectDocumentName(e) }}>
                        <option value="Firm Rent Agreement">Firm Rent Agreement</option>
                        <option value="Tax Bill / Gas Bill / Electicity Bill / Telephone Bill">Tax Bill / Gas Bill / Electicity Bill / Telephone Bill</option>
                        <option value="Firm Image">Firm Image</option>
                        <option value="Pan">Pan</option>
                        <option value="Registration Certificate">Registration Certificate</option>
                      </select>
                    }
                  </div>

                  <div className="upload-btn-wrapper">
                    <img src={EditIcon} className="doc-edit-icon" alt="" />
                    <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e) }} />
                  </div>
                  <img src={doc && doc.document_url ? imageEndpoint + doc.document_url : NoImage} className="update-prof-img-box" alt="" />
                </div>
                <label className="redio-lavel-txt" >Upload Document</label>
                {
                  role == "Admin" && 
                  <div>
                    <Button type="submit" disabled={ doc && doc.status === "Verified"} className="ant-btn btn-login" onClick={() => {this.approveRejectUserDocument(doc && doc.id, 'V')}}><span>{ doc && doc.status == "Verified" ? 'Approved' : "Approve"}</span></Button>
                    <Button type="button" disabled={ doc && doc.status === "Rejected"} className="ant-btn btn-reject" onClick={() => {this.approveRejectUserDocument(doc && doc.id, 'R')}}><span>{ doc && doc.status == "Rejected" ? 'Rejected' : "Reject"}</span></Button>
                  </div>
                }
              </div>
            </div>
          </div>
          {
            role != "Admin" && 
            <div>
              <Button htmlType="submit" className='btn-login'>SAVE</Button>
            </div>
          }
          
        </form>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  }
}
export default connect(mapStateToProps)(FirmDetail);